import { render, staticRenderFns } from "./Show.vue?vue&type=template&id=c20b18f4&"
import script from "./Show.vue?vue&type=script&lang=js&"
export * from "./Show.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./Show.vue?vue&type=custom&index=0&blockType=styles&scoped=true&lang=scss"
if (typeof block0 === 'function') block0(component)

export default component.exports